export const typeChipStyles = (bg: string, color: string) => ({
  backgroundColor: bg,
  color,
  padding: "3px 16px",
  borderRadius: "38px",
  letterSpacing: "0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "0.5em",
  height: "24px",

  "& p": {
    fontSize: "0.75rem",
    textAlign: "center",
    fontWeight: "500",
  },
});

export const IconButtonStyle = {
  width: "30px",
  height: "30px",
  padding: "5px",
  marginLeft: "8px",
};
